module.exports = __webpack_public_path__ + "static/media/couple_in_mountains.5fb721c0.jpg";